import React from 'react';
import { faGrip, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { getLocalDateKey } from './dateUtils';
import { DraftTaskSelection } from './types';
import { useTimelineView } from './TimelineViewContext';
import { getEndTimeForRange } from './timelineViewUtils';

export const TimelineDraftSelection: React.FC<{ selection: DraftTaskSelection; top: number }> = ({ selection, top }) => {
    const { t } = useTranslation();
    const {
        creationMenuKey, creationMenuRef, onCancelDraftSelection, onConfirmDraftSelection,
        onDraftPointerDown, onDraftResizePointerDown, onPickExistingTask, setCreationMenuKey,
        timeSlotHeight,
    } = useTimelineView();
    const key = `draft-${getLocalDateKey(selection.date)}-${selection.startTime}`;
    const [hours, minutes] = selection.startTime.split(':').map(Number);
    return (
        <div className="drag-preview timeline-hour-drag-preview draft-selection-preview"
            onPointerDown={onDraftPointerDown}
            style={{ top: `${top}px`, height: `${selection.duration / 60 * timeSlotHeight}px` }}>
            <div className="resize-handle resize-handle-top draft-selection-resize-handle"
                onPointerDown={(event) => onDraftResizePointerDown('top', event)}>
                <FontAwesomeIcon icon={faGrip} />
            </div>
            <div className="drag-preview-content">
                <span className="drag-preview-time">
                    {selection.startTime} - {getEndTimeForRange(selection.startTime, selection.duration)}
                </span>
                <div className="draft-selection-actions">
                    <button type="button" className="draft-selection-button"
                        aria-label={t('dailyPlanner.addTask')}
                        onClick={(event) => { event.stopPropagation(); setCreationMenuKey((current) => current === key ? null : key); }}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                    {creationMenuKey === key && (
                        <div ref={creationMenuRef} className="timeline-create-choice-menu timeline-draft-choice-menu"
                            role="menu" onClick={(event) => event.stopPropagation()}>
                            <button type="button" role="menuitem"
                                onClick={() => { setCreationMenuKey(null); onConfirmDraftSelection(); }}>
                                {t('dailyPlanner.newTask')}
                            </button>
                            <button type="button" role="menuitem" onClick={() => {
                                const date = new Date(selection.date);
                                date.setHours(hours, minutes, 0, 0);
                                setCreationMenuKey(null);
                                onPickExistingTask(date);
                                onCancelDraftSelection();
                            }}>
                                {t('dailyPlanner.existingTask')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className="resize-handle resize-handle-bottom draft-selection-resize-handle"
                onPointerDown={(event) => onDraftResizePointerDown('bottom', event)}>
                <FontAwesomeIcon icon={faGrip} />
            </div>
        </div>
    );
};
